import React from 'react';
import { translate } from 'react-polyglot';
import { taggedLink } from '../helpers/linkTagging';

const CertifiedByLiveChat = ({ t }, props) =>
  <div className="certified">
    <a
      target="_blank"
      href={`https://www.livechatinc.com/powered-by-livechat/${taggedLink(
        props,
        'certified-by-livechat'
      )}`}
    >
      {' '}<span>{t('quality_verified_by_livechat')}</span>
      <img
        src="https://cdn.livechatinc.com/mailing/logo.png"
        height="50"
        alt=""
      />
    </a>
  </div>;

export default translate()(CertifiedByLiveChat);



// WEBPACK FOOTER //
// ./src/components/CertifiedByLiveChat.js